// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CreateCashRegisterMutationVariables = Types.Exact<{
  upsertCashRegisterDTO: Types.UpsertCashRegisterDtoInput;
}>;


export type CreateCashRegisterMutationResult = { __typename?: 'Mutation', createCashRegister: number | null };

export const CreateCashRegisterGql = gql`
    mutation CreateCashRegister($upsertCashRegisterDTO: UpsertCashRegisterDTOInput!) {
  createCashRegister(upsertCashRegisterDTO: $upsertCashRegisterDTO)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCashRegisterInjectable extends Apollo.Mutation<CreateCashRegisterMutationResult, CreateCashRegisterMutationVariables> {
    override document = CreateCashRegisterGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */